import { createFileRoute } from '@tanstack/react-router';

import { SiteConfigPage } from '../../../features/site-config/settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/site')({
  // Конфигуратор сайта считает по услугам каталога — настраивает тот, кто ведёт каталог.
  beforeLoad: requireSettingsPermission('catalog.manage'),
  component: SiteConfigPage,
});
